export type MediaComposition = "portrait" | "landscapeOrSquare";

export const getMediaComposition = (width: number, height: number): MediaComposition =>
  height > width ? "portrait" : "landscapeOrSquare";

export const objectFitByComposition: Record<MediaComposition, "object-cover" | "object-contain"> = {
  portrait: "object-cover",
  landscapeOrSquare: "object-contain",
};
